import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import {
  Affiliate,
  AffiliateBannerConfig,
  AffiliateGridItem,
} from 'anchor-shared/lib/model/entity/affiliate';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

@Injectable()
export class AffiliateDAO extends BaseDAO<string> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.AFFILIATE);
  }

  public checkValidity(vanity: string): Observable<AffiliateBannerConfig> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/valid/' + vanity;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<AffiliateBannerConfig>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public setSelfAsAffiliate(addRole: boolean): Observable<boolean> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/set-self';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      addRole: addRole,
    };
    return this.apiHelper.apiCall<boolean>(url, method, null, data, headers);
  }

  public getAffiliateCharters(
    fromDate: string,
    toDate: string,
  ): Observable<Charter[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/affiliate-charters';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      fromDate: fromDate,
      toDate: toDate,
    };
    return this.apiHelper.apiCall<Charter[]>(url, method, null, data, headers);
  }

  public adminGrid(): Observable<AffiliateGridItem[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/admin/grid/data';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<AffiliateGridItem[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getVanityForUser(): Observable<{ vanity: string }> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/user-vanity';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{ vanity: string }>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public loadForUser(): Observable<AffiliateBannerConfig> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/banner';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<AffiliateBannerConfig>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getAffiliateInfoForUser(): Observable<Partial<Affiliate>> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/affiliate-info';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Partial<Affiliate>>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getByUserId(): Observable<Affiliate> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/user';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Affiliate>(url, method, null, null, headers);
  }

  public updateFromPartial(
    affiliateId: number,
    partialAffiliate: Partial<Affiliate>,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/partial/' +
      affiliateId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Payout[]>(
      url,
      method,
      null,
      partialAffiliate,
      headers,
    );
  }

  public loadUserForAdmin(userId: number): Observable<AffiliateBannerConfig> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/banner/' +
      userId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<AffiliateBannerConfig>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  getAffiliateNameAndPhotoByCharterId(
    charterId: number,
  ): Observable<AffiliateNameAndPhoto> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/affiliate-name-and-photo/' +
      charterId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<AffiliateNameAndPhoto>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  affiliateCanSaveVanity(proposedVanity: string): Observable<boolean> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vanity/is-unique/' +
      proposedVanity;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<boolean>(url, method, null, null, headers);
  }
}

export interface AffiliateNameAndPhoto {
  affiliateId: number;
  displayName: string;
  logoPath: string;
}
